import React from "react";
import "./Loader.scss";
import PropTypes from "prop-types";

function Loader({ text, children }) {
  return (
    <div className="theme-loader">
      <div className="theme-loader__container">
        <div className="theme-loader__spinner">
          <div className="lds-spinner">
            <div />
            <div />
            <div />
            <div />
            <div />
            <div />
            <div />
            <div />
            <div />
            <div />
            <div />
            <div />
          </div>
          <br />
          {text}
          {children}
        </div>
      </div>
    </div>
  );
}

Loader.defaultProps = {
  text: "loading...",
};
Loader.propTypes = {
  text: PropTypes.string,
};

export default Loader;
